import { useCallback } from 'react';
import { sendChatJoinChannelEvent, sendChatLeaveChannelEvent } from '@connect-x-app/hybrid-data-access';

export const useChatChannelSocketSendEvents = () => {
  const sendChatJoinChannel = useCallback(async (chatroomId: string, channelId: string) => {
    return await sendChatJoinChannelEvent(chatroomId, channelId);
  }, []);

  const sendChatLeaveChannel = useCallback(async (chatroomId: string, channelId: string) => {
    return await sendChatLeaveChannelEvent(chatroomId, channelId);
  }, []);

  return { sendChatJoinChannel, sendChatLeaveChannel };
};
